import React, { useEffect, useState } from 'react';
import 'moment/locale/pt';
import { Box, Button, CircularProgress, FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { DateTimePicker } from '@mui/x-date-pickers';

import dayjs from 'dayjs';
import { enqueueSnackbar } from 'notistack';
import { PostFetch, PutFetch } from '../../../../../services/apiBase';

export default function PromoCodeModal({ onEdit, editPromoCode, onClose, getList }) {

  const user = JSON.parse(localStorage.getItem('user'))
  const [load, setLoad] = useState(false);

  const [startDate, setStartDate] = useState(onEdit ? dayjs(editPromoCode.date_initial) : null);
  const [expiresDate, setExpiresDate] = useState(onEdit ? dayjs(editPromoCode.date_expires) : null);

  const [promotionalCode, setPromotionalCode] = useState({
    cod: onEdit ? editPromoCode.cod : '',
    description: onEdit ? editPromoCode.description : '',
    rate: onEdit ? editPromoCode.rate : '',
    amount_start: onEdit ? editPromoCode.amount_start : '',
    amount_end:  onEdit ? editPromoCode.amount_end : '',
    years: onEdit ? editPromoCode.years : '',
    date_initial: onEdit ? editPromoCode.date_initial : null,
    date_expires: onEdit ? editPromoCode.date_expires : null,
    is_active: onEdit ? editPromoCode.is_active : true,
    username: user.username,
    type: onEdit ? editPromoCode.type : 'REGULAR',
    months: onEdit ? editPromoCode.months : '',
    duration: onEdit ? editPromoCode.months : ''
  });

  const formatDate = (date) => {
    let d = new Date(date)
    return d.toISOString()
  }

  const floatConversor = (event) => {
    if (event.nativeEvent.data === ',') {
      let newValue = promotionalCode.rate + '.'
      setPromotionalCode({ ...promotionalCode, ['rate']: newValue })
    } else {
      handleOnChange(event)
    }
  }

  const handleOnChange = (e) => {
    let key = e.target.id
    let value = e.target.value
    setPromotionalCode({ ...promotionalCode, [key]: value })
  }

  const handleOnCloseModal = () => {
    onClose()
  }

  const handleSubmit = async () => {
    try {
      setLoad(true)
      if (onEdit) {
        await PutFetch(`/financial/promotionalCupom`,
          {
            "id": editPromoCode.id,
            "cod": promotionalCode.cod,
            "description": promotionalCode.description,
            "rate": Number(promotionalCode.rate),
            "amount_start": Number(promotionalCode.amount_start),
            "amount_end":  Number(promotionalCode.amount_end),
            "years": null,
            "date_initial": formatDate(startDate),
            "date_expires": formatDate(expiresDate),
            "is_active": promotionalCode.is_active,
            "username": user.username,
            "type": promotionalCode.type,
            "months": Number(promotionalCode.duration)
          });

        enqueueSnackbar('Código promocional editado com sucesso!', { variant: 'success' });
        
      } else {
        await PostFetch(`/financial/promotionalCupom`,
          {
            "cod": promotionalCode.cod,
            "description": promotionalCode.description,
            "rate": Number(promotionalCode.rate),
            "amount_start": Number(promotionalCode.amount_start),
            "amount_end":  Number(promotionalCode.amount_end),
            "years": null,
            "date_initial": formatDate(startDate),
            "date_expires": formatDate(expiresDate),
            "is_active": true,
            "username": user.username,
            "type": promotionalCode.type ? promotionalCode.type : 'REGULAR',
            "months": Number(promotionalCode.duration)
          });

        enqueueSnackbar('Código promocional cadastrado com sucesso!', { variant: 'success' });

      }
      handleOnCloseModal()
      getList()
      setLoad(false)
    } catch (error) {
      let message = onEdit ? 'Erro ao editar código promocional' : 'Erro ao cadastrar novo código promocional'
      enqueueSnackbar(message, { variant: 'error' });

      handleOnCloseModal()
      setLoad(false)
    }
  }

  function validateForm() {
    if((promotionalCode.cod === '')
    || promotionalCode.description === ''
    || promotionalCode.rate === ''
    || promotionalCode.amount_start === ''
    || promotionalCode.amount_end === ''
    || promotionalCode.date_initial === ''
    || promotionalCode.date_expires === ''
    )
    {
      return true
    } else {
      return false
    }
  }

  useEffect(() => {
    if (editPromoCode && editPromoCode.years !== null) {
      setPromotionalCode({ ...promotionalCode, ['duraction']: editPromoCode.years * 12 })
    } 
  }, [editPromoCode])

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          {onEdit ? `Editando ${editPromoCode.cod}` : 'Cadastrar novo código promocional'}
        </Typography>
      </Box>

      <Box sx={{
        marginTop: '16px',
        marginBottom: '16px',
        marginRight: '32px',
        width: 400,
        minWidth: 400,
        maxHeight: '80%',
        height: '90%',
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        gap: 2
      }}>
        {!onEdit && 
          <FormControl fullWidth>
            <TextField
              id={`cod`}
              label="Código"
              value={promotionalCode.cod}
              onChange={(event) => {
                handleOnChange(event);
              }}
            />
          </FormControl>
        }

        <FormControl fullWidth>
          <TextField
            id={`description`}
            label="Descrição"
            value={promotionalCode.description}
            onChange={(event) => {
              handleOnChange(event);
            }}
          />
        </FormControl>

        <FormControl fullWidth>
          <InputLabel id="is_actived">Selecione o tipo</InputLabel>
          <Select
            labelId="is_actived"
            id="type"
            name="is_actived" 
            label="Selecione o tipo"
            value={promotionalCode.type}
            onChange={event => {
              setPromotionalCode({ ...promotionalCode, ['type']: event.target.value });
            }}
          >
            <MenuItem value={'REGULAR'}>Regular</MenuItem>
            <MenuItem value={'IPCA'}>IPCA</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel id="rate">Taxa</InputLabel>
          <OutlinedInput
            id={`rate`}
            endAdornment={<InputAdornment position="end">%</InputAdornment>}
            label="Taxa"
            value={promotionalCode.rate}
            onChange={(event) => {
              floatConversor(event);
            }}
          />
        </FormControl>

        <FormControl fullWidth>
          <TextField
            id={`amount_start`}
            label="Valor mínimo"
            type="number"
            value={promotionalCode.amount_start}
            onChange={(event) => {
              handleOnChange(event);
            }}
          />
        </FormControl>

        <FormControl fullWidth>
          <TextField
            id={`amount_end`}
            label="Valor máximo"
            type="number"
            value={promotionalCode.amount_end}
            onChange={(event) => {
              handleOnChange(event);
            }}
          />
        </FormControl>

        <FormControl fullWidth>
          <TextField
            id={`duration`}
            label="Tempo de investimento (meses)"
            type="number"
            value={promotionalCode.duration}
            onChange={(event) => {
              handleOnChange(event);
            }}
          />
        </FormControl>

        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          border: '1px solid',
          padding: 2,
          borderRadius: 1,
        }}>
          <DateTimePicker
            label="Data inicial"
            id="date_initial"
            name='date_initial'
            value={startDate}
            ampm={false}
            format="DD/MM/YYYY HH:mm"
            onChange={(value) => setStartDate(value )}
          />

          <DateTimePicker
            label="Data final"
            id="date_expires"
            value={expiresDate}
            ampm={false}
            format="DD/MM/YYYY HH:mm"
            onChange={(newValue) => setExpiresDate(newValue)}
          />
        </Box>

        <FormControl fullWidth>
          <InputLabel id="is_actived">Status</InputLabel>
          <Select
            labelId="is_actived"
            id="type"
            name="is_actived" 
            label="Status"
            value={promotionalCode.is_active}
            onChange={event => {
              setPromotionalCode({ ...promotionalCode, ['is_active']: event.target.value });
            }}
          >
            <MenuItem value={true}>Ativado</MenuItem>
            <MenuItem value={false}>Desativado</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button disabled={load || validateForm()} variant="contained" color={'success'}>
          <Typography color={'#fff'} onClick={() => handleSubmit()}>
            {load? <CircularProgress color='success' /> : onEdit ? 'Salvar' : 'Cadastrar'}
          </Typography>
        </Button>
        <Button variant="contained" color='error' onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
